import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import i18next, { t } from 'i18next';
import { IconButton } from '@fluentui/react';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../common/Helpers';
import { action_updateContractPartieItem, action_updateContractPartieList, action_updateContractPartieSelected, action_updateContractPartieSelectedId, action_updateContractPartieSidePanelIsOpen, action_updateGeneralMessage } from '../../../../../reducers/actions/PAY/actions';
import { enum__ENUM_CLASE_PARTIDA, enum_CONTACTPARTIE_POLINOMY_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG, enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE, enum_ENUM_CLASES_PARTIDA_TIPO_CLASE } from '../../../../../common/Dictionaries';
import TableResourceHeads from '../Resource/TableHeads';
import TableResourceItems from '../Resource/TableResourceItems';
import TablePolynomyItems from '../../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItems';
import { Col, Row } from 'react-bootstrap';
import { deletePartie } from '../../../../../services/sPay/partie.service';
import DeleteAdvaiceDialog from '../../Dialogs/DeleteAdvaiceDialog';
import { _handleDeletePolynomyClick } from '../../../Events';
import { useGetContractModificationMaintainer } from '../../../../../hooks/services/sKPI/useOfContractModification';

const TableItem = ({ tableItem, tableHeads, editEnabled, list_mc }) => {

  const dispatch = useDispatch();

  const {
    _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
    _contractParties: contractParties,
  } = useSelector((state) => state.contractPartiesState);

  const [showDeleteAdvice, setShowDeleteAdvice] = useState(false);

  const handleViewItem = () => {
    const contractPartieId = tableItem.id;
    const isPanelOpen = contractPartieSidePanelsConfig.contractSubParties;
    dispatch(action_updateContractPartieSelectedId(contractPartieId))
    dispatch(action_updateContractPartieSelected(tableItem))
    dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_VIEW, !isPanelOpen))
  };

  const handleDeleteClick = async (responseFlag, tableItemId) => {
    if (responseFlag) {
      await deletePartie(tableItemId).then((response) => {
        if (response.data.succeeded) {
          dispatch(action_updateContractPartieList(contractParties.filter(x => x.id !== tableItemId)));
          dispatch(action_updateGeneralMessage(t('data-lang-msg-operationsucces')))
        }
        else {
            dispatch(action_updateGeneralMessage(t('data-lang-msg-operationerror'), true))
          }
      }).catch(() => {
          dispatch(action_updateGeneralMessage(t('data-lang-msg-operationerror'), true))
      });
    }
  };

  const handlePreDeleteClick = () => {
    setShowDeleteAdvice(true);
  }

  const handleAddSubPartie = () => {
    const contractPartieId = tableItem.id;
    const isPanelOpen = contractPartieSidePanelsConfig.isPanelEditSubPartieOpen;
    dispatch(action_updateContractPartieSelectedId(contractPartieId))
    dispatch(action_updateContractPartieSelected(tableItem))
    dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_INSERT, !isPanelOpen))
  };

  const handleEditClick = () => {
    const contractPartieId = tableItem.id;
    const isPanelOpen = contractPartieSidePanelsConfig.isPanelEditPartieOpen;
    dispatch(action_updateContractPartieSelectedId(contractPartieId))
    dispatch(action_updateContractPartieSelected(tableItem))
    dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_EDIT, !isPanelOpen))
  };

  const handleToggleRow = (item) => {
    item.collapse = isNullUndefinedOrEmpty(item.collapse) ? false : !item.collapse
    dispatch(action_updateContractPartieItem(item))
  };

  return (
    <>
      <tr>
        <td className='text-end'>
          <IconButton iconProps={{ iconName:((!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true) ? "CirclePlus" : "Blocked2") }} onClick={() => handleToggleRow(tableItem)}/>
        </td>
        <td><span>{tableItem.iteM_PARTIDA.nroPartida}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.codigoPartida}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.clasePartidaTitle}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.tipoPartidaTitle}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.nombrePartida}</span></td>
        <td><span>{!isNullUndefined(list_mc) ? (!isNullUndefined(tableItem.iteM_PARTIDA.mcNombre) ? tableItem.iteM_PARTIDA.mcNombre : (!isNullUndefined(list_mc.find(x => x.id === tableItem.iteM_PARTIDA.idMcContrato)) ? list_mc.find(x => x.id === tableItem.iteM_PARTIDA.idMcContrato).changeCode : "")) : ""}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.mesInicioPartida}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.mesTerminoPartida}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.mesPrevio}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.monedaPartida}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.gastoPrevioBasePartida !== null ? tableItem.iteM_PARTIDA.gastoPrevioBasePartida.toLocaleString(i18next.language, {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.montoTotalPartida !== null ? tableItem.iteM_PARTIDA.montoTotalPartida.toLocaleString(i18next.language, {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""}</span></td>
        <td><span>{tableItem.iteM_PARTIDA.codigoInterno}</span></td>
        <td className='text-end'>
          {
            editEnabled && (tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS || tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS) &&
            <IconButton
              className="btn btn-outline-secondary btn-sm delete-btn me-1"
              iconProps={{iconName: "Add"}}
              onClick={handleAddSubPartie}
              title={t('data-lang-btn-addsubpartie')}
            />
          }
          <IconButton
            className="btn btn-outline-secondary btn-sm delete-btn me-1"
            iconProps={{iconName: "View"}}
            onClick={handleViewItem}
            title={t('data-lang-btn-view')}
          />
          {
            editEnabled &&
            <>
              <IconButton
                className="btn btn-outline-primary btn-sm mr-2 edit-btn me-1"
                iconProps={{iconName: "Edit"}}
                onClick={handleEditClick}
                title={t('data-lang-btn-edit')}
              />
              <IconButton
                className="btn btn-outline-danger btn-sm delete-btn"
                iconProps={{iconName: "Delete"}}
                onClick={handlePreDeleteClick}
                title={t('data-lang-btn-delete')}
              />          
          </>
          }
        </td>
      </tr>
      {
        (!(!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true) && tableItem.l_SUBPARTIDA.length > 0) &&
        <tr>
          <td colSpan={15}>
            <table className="table table-striped table-bordered table-sm">
                <TableResourceHeads tableHeads={tableHeads} />
                <TableResourceItems tableItems={tableItem.l_SUBPARTIDA} contractPartieId={tableItem.iteM_PARTIDA.id} handleEditFormOpen={null} handleAnswerFormLoad={null} editEnabled={editEnabled} />
            </table>
          </td>
        </tr>
      }
      {
        (!(!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true)) &&
        <tr>
          <td colSpan={15}>
            <Row>
              <Col className='col-auto me-auto'>
                <Row ID="vPartida">
                  <Col>
                  {
                    tableItem.iteM_PARTIDA.claseTipoPartidaId === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO &&
                    <Row ID="pnlPS" className='text-nowrap'>
                      <Col>
                          <Row className="moduloInfoLeft ">
                            <Col className="headerDetailPartida">Unidad servicio</Col>
                            <Col className="">
                              {
                                tableItem.iteM_PARTIDA.claseTipoPartidaId === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO ?
                                tableItem.iteM_PARTIDA.unidadPartidaTitle : "S/D"
                              } 
                            </Col>
                          </Row>
                          <Row className="moduloInfoLeft">
                            <Col clclassNameass="headerDetailPartida">Cantidad total </Col>
                            <Col className="">
                              {
                                tableItem.iteM_PARTIDA.claseTipoPartidaId === enum_ENUM_CLASES_PARTIDA_TIPO_CLASE.SERVICIO ?
                                tableItem.iteM_PARTIDA.cantidadTotalServicio && tableItem.iteM_PARTIDA.cantidadTotalServicio.toLocaleString(i18next.language) : "S/D"
                              }
                            </Col>
                          </Row>
                      </Col>
                    </Row>
                  }
                  {
                    (tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA || tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA) &&
                    <Row ID="pnlPSumaAlzada"  className='text-nowrap moduloInfoLeft'>
                      <Col className="headerDetailPartida">Monto total suma alzada </Col>
                      <Col className="">
                        {
                          (tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_SUMA_ALZADA || tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PCI_SUMA_ALZADA) ?
                          tableItem.iteM_PARTIDA.montoTotalSumaAlzadaPartida && parseFloat(tableItem.iteM_PARTIDA.montoTotalSumaAlzadaPartida).toLocaleString(i18next.language) : "S/D"
                        }
                      </Col>
                    </Row>
                  }
                  {
                    tableItem.iteM_PARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.PSP_PRECIO_UNITARIO &&
                    <Row ID="pnlPSPrecioUnitario" className='text-nowrap' >
                      <Col className="moduloInfoLeft">
                          <Row>
                              <Col className="headerDetailPartida">Precio unitario base </Col>
                              <Col className="">
                                  {
                                    tableItem.iteM_PARTIDA.claseTipoPartidaId === enum__ENUM_CLASE_PARTIDA.PSP_PRECIO_UNITARIO ?
                                    tableItem.iteM_PARTIDA.precioUnitarioBasePartida && parseFloat(tableItem.iteM_PARTIDA.precioUnitarioBasePartida).toLocaleString(i18next.language) : "S/D"
                                  }
                              </Col>
                          </Row>
                      </Col>
                    </Row>
                  }
                  </Col>
                </Row>
              </Col>
              {
                (tableItem.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS && tableItem.iteM_PARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS) &&
                <Col className='d-flex w-100'>
                  <TablePolynomyItems
                    tableItems={tableItem.l_POLINOMIO}
                    parentId={tableItem.iteM_PARTIDA.id}
                    hasResources={tableItem.l_SUBPARTIDA.length > 0}
                    parentPolinomyType={enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.PARTIE}
                    handleDeletePolynomy={_handleDeletePolynomyClick}
                    polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.SIMPLE_VIEW}
                  />
                </Col>
              }
            </Row>
          </td>
        </tr>
      }
      {
        <DeleteAdvaiceDialog
          isModalOpen={showDeleteAdvice}
          setIsModalOpen={setShowDeleteAdvice}
          setterAction={handleDeleteClick}
          itemIdToDelete={tableItem.id}
        />
      }
    </>
  );
};

TableItem.propTypes = {
  tableItem: PropTypes.shape({
    id: PropTypes.number,
    subject: PropTypes.string,
    category: PropTypes.string,
    assignee: PropTypes.string,
    priority: PropTypes.string,
    status: PropTypes.string,
    update: PropTypes.bool,
    creation_date: PropTypes.string,
    answers_number: PropTypes.number,
    has_docs: PropTypes.bool
  }),
};

TableItem.defaultProps = {
  tableItem: {
    id: 1,
    subject: 'A new rating has been received',
    category: 'Marketing',
    assignee: 'Erwin',
    priority: 'Medium',
    status: 'Open',
    update: false,
    creation_date: '',
    answers_number: 0,
    has_docs: false
  },
};

export default TableItem;
